import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { MagazineTemplateForm } from "../MagazineTemplateForm";
import { EditMagazineTemplateModalProps } from "./types";
import { useEditMagazineTemplateModal } from "./controller";

export const EditMagazineTemplateModal = React.memo(({ modalRef, onComplete }: EditMagazineTemplateModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditMagazineTemplateModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("magazine/magazine_template_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <MagazineTemplateForm />
    </Modal>
  );
});
